import React, { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Copy, Download, ExternalLink } from "lucide-react";
import { toast } from "sonner";

export default function SharePanel({ tournament }) {
  const ref = useRef(null);
  const regUrl = `${window.location.origin}/tournaments/${tournament.slug}/register`;
  const pageUrl = `${window.location.origin}/tournaments/${tournament.slug}`;
  const copy = (txt) => navigator.clipboard.writeText(txt).then(() => toast.success("Link copied"));
  const download = () => {
    const a = document.createElement("a");
    a.href = ref.current.querySelector("canvas").toDataURL("image/png");
    a.download = `${tournament.slug}-registration-qr.png`;
    a.click();
  };
  const Link = ({ label, url, testid }) => (
    <div>
      <div className="text-xs font-semibold text-white/50 mb-1.5">{label}</div>
      <div className="flex gap-2">
        <input readOnly value={url} className="flex-1 min-w-0 px-3 py-2 rounded-lg bg-black/30 border border-white/10 text-xs text-white/80" data-testid={`${testid}-input`} />
        <button onClick={() => copy(url)} className="px-3 rounded-lg bg-white/10 text-white hover:bg-white/20" data-testid={`${testid}-copy`}><Copy size={14} /></button>
        <a href={url} target="_blank" rel="noreferrer" className="px-3 rounded-lg bg-white/10 text-white hover:bg-white/20 grid place-items-center"><ExternalLink size={14} /></a>
      </div>
    </div>
  );
  return (
    <div className="grid md:grid-cols-[auto_1fr] gap-6 items-start" data-testid="share-panel">
      <div className="text-center">
        <div ref={ref} className="p-3 rounded-xl bg-white inline-block" data-testid="registration-qr"><QRCodeCanvas value={regUrl} size={180} level="M" /></div>
        <button onClick={download} className="mt-3 w-full py-2 rounded-lg bg-white/10 text-white text-xs font-semibold flex items-center justify-center gap-1.5 hover:bg-white/20" data-testid="qr-download"><Download size={13} /> Download QR</button>
      </div>
      <div className="space-y-4">
        <Link label="Team registration link" url={regUrl} testid="share-reg" />
        <Link label="Public tournament page" url={pageUrl} testid="share-page" />
        {!tournament.published && <div className="text-xs text-amber-400 bg-amber-500/10 rounded-lg px-3 py-2">These links go live after the payment is completed.</div>}
        {!tournament.registration_open && <div className="text-xs text-white/50 bg-white/5 rounded-lg px-3 py-2">Registration is currently closed. Turn it on in the Details tab.</div>}
      </div>
    </div>
  );
}
